import * as React from 'react';

export type SpinnerProps = {
  size?: number;
  tone?: 'brand' | 'current';
  className?: string;
  testId?: string;
} & Omit<React.HTMLAttributes<HTMLSpanElement>, 'className'>;

export function Spinner({
  size = 24,
  tone = 'brand',
  className = '',
  testId,
  style,
  ...rest
}: SpinnerProps) {
  return (
    <span
      role="status"
      aria-label="loading"
      data-testid={testId}
      style={{
        width: size,
        height: size,
        ...(tone === 'current'
          ? {
              borderColor: 'color-mix(in srgb, currentColor 25%, transparent)',
              borderTopColor: 'currentColor',
            }
          : {}),
        ...style,
      }}
      className={`inline-block shrink-0 animate-spin rounded-full border-2! border-solid! ${
        tone === 'brand' ? 'border-[#E0E2E6]! border-t-[#F2DC39]!' : ''
      } ${className}`}
      {...rest}
    />
  );
}
